module.exports = __webpack_public_path__ + "static/media/tree-left.8b2cfa28.png";